import { useLanguage } from '@/localization'

interface SectionHeadingProps {
  eyebrow: string
  title: string
  subtitle?: string
  className?: string
}

/**
 * Centered section heading using the cross-game twin-rule eyebrow treatment
 * (pixel font + green accent rules), echoing the hero subtitle. Used on every
 * home/section block so the page reads with one consistent rhythm instead of
 * each section inventing its own header.
 */
export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  className = '',
}: SectionHeadingProps) {
  const { t } = useLanguage()

  return (
    <div className={['mx-auto mb-12 max-w-2xl text-center', className].filter(Boolean).join(' ')}>
      <div className="mb-4 flex items-center justify-center gap-3">
        <span className="h-[3px] w-8 bg-gradient-to-r from-transparent to-grass-dark sm:w-12" />
        <span className="font-pixel text-[10px] uppercase tracking-[0.25em] text-grass-deep">
          {t(eyebrow)}
        </span>
        <span className="h-[3px] w-8 bg-gradient-to-l from-transparent to-grass-dark sm:w-12" />
      </div>
      <h2 className="font-extrabold text-3xl text-slate-deep sm:text-4xl">{t(title)}</h2>
      {subtitle && (
        <p className="mx-auto mt-4 max-w-xl text-lg text-slate-deep/70">{t(subtitle)}</p>
      )}
    </div>
  )
}
